import { render, staticRenderFns } from "./SideBarKnit.vue?vue&type=template&id=b0e39d7e"
import script from "./SideBarKnit.vue?vue&type=script&lang=js"
export * from "./SideBarKnit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports